import http from '@/util/http'

export default {

    findBillStatus() {
        return http.get('/BillLog/api/findBillStatus');
    },

    getBillLogMonths() {
        return http.get('/BillLog/api/getBillLogMonths');
    },

    billLogEMailCheck() {
        return http.get('/BillLog/api/billLogEMailCheck');
    },

    billLogMailCheck() {
        return http.get('/BillLog/api/billLogMailCheck');
    },

    checkMailVerifyCode(verifyCode, randomCode) {
        return http.get('/BillLog/api/checkMailVerifyCode', { params: { verifyCode, randomCode } });
    },
    checkEMailVerifyCode(payload) {
        return http.post('/BillLog/api/checkEMailVerifyCode', payload);
    },
    cancelBillStatus() {
        return http.get('/BillLog/api/cancelBillStatus');
    },
    sendDetailBillEMail(confirmCode) {
        return http.get('/BillLog/api/sendDetailBillEMail', { params: { confirmCode } })
    }
}


// WEBPACK FOOTER //
// ./src/api/billLog/billLogApi.js